module.exports = __webpack_public_path__ + "img/联系.46038141.svg";